<template>
  <div class="event-board">
    <div class="header">
      <h1>事件滚动看板</h1>
      <div class="header-controls">
        <!-- <div class="date-range-control">
          <div class="date-inputs">
            <input type="date" v-model="startDate" @change="onDateChange" />
            <span class="date-separator">至</span>
            <input type="date" v-model="endDate" @change="onDateChange" />
          </div>
        </div> -->
        <div class="speed-control">
          <!-- <label>滚动速度：</label> -->
          <select v-model="scrollSpeed" @change="updateScrollSpeed">
            <option value="slow">慢速</option>
            <option value="medium">中速</option>
            <option value="fast">快速</option>
          </select>
        </div>
        <!-- <button class="refresh-btn" @click="refreshData">刷新数据</button> -->
      </div>
    </div>
    
    <div class="table-container">
      <!-- 表头 -->
      <div class="table-header">
        <div class="header-cell device-col">设备</div>
        <div class="header-cell title-col">事件标题</div>
        <div class="header-cell handler-col">处理人</div>
        <div class="header-cell handler-col">上报时间</div>
        <div class="header-cell duration-col">耗时</div>
        <div class="header-cell status-col">状态</div>
      </div>
      
      <!-- 表体 -->
      <div class="table-body-container">
        <div v-if="events.length === 0" class="no-data">
          暂无数据
        </div>
        <div v-else class="table-body" ref="tableBody">
          <div v-for="(event, index) in events" :key="index" :class="['table-row', event.status&&event.status.value]">
            <div class="row-cell device-col">{{ event.deviceName }}</div>
            <div class="row-cell title-col">{{ event.evtRecTitle }}</div>
            <div class="row-cell handler-col">{{ event.handlerBy }}</div>
            <div class="row-cell handler-col">{{ event.triggerTime }}</div>
            <div class="row-cell duration-col">{{ event.duration }}</div>
            <div class="row-cell status-col">
              <span :class="['status-badge', event.status&&event.status.value]">{{ event.status&&event.status.label }}</span>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 统计栏 -->
      <div class="statistics-bar">
        <div class="stat-item">
          <span class="stat-dot EVT_PENDING"></span>
          待处理：{{ stats.pending }}
        </div>
        <div class="stat-item">
          <span class="stat-dot EVT_PROCESSING"></span>
          处理中：{{ stats.processing }}
        </div>
        <div class="stat-item">
          <span class="stat-dot EVT_DONE"></span>
          已完成：{{ stats.confirming }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { andonEvtRecList } from "@/api/bigscreen/bigscreen";
export default {
  props: {
    organizationId: {
      type: String,
      default: ''
    }
  },

  data() {
    // 计算当前日期和当月第一天
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(1); // 设置为当月第一天
    
    // 格式化为YYYY-MM-DD
    const formatDate = (date) => {
      return date.toISOString().split('T')[0];
    };
    
    return {
      scrollSpeed: 'slow',
      scrollInterval: null,
      scrollStep: 2,
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
      stats: {
        pending: 0,
        processing: 0,
        confirming: 0
      },
      events: []
    }
  },
  mounted() {
    // this.startScroll();
    this.getList()
  },
  beforeUnmount() {
    if (this.scrollInterval) {
      clearInterval(this.scrollInterval);
    }
  },
  methods: {
    getList(){
      const params = {
        statusList:'EVT_PROCESSING,EVT_DONE,EVT_PENDING',//['EVT_PROCESSING','EVT_DONE','EVT_PENDING']
        deptId:this.organizationId,
        orderBy:'asc'
      };
      
      // // 添加日期范围参数
      // if (this.startDate) {
      //   params.createTimeStart = this.startDate+' 00:00:00';
      // }
      // if (this.endDate) {
      //   params.createTimeEnd = this.endDate+' 23:59:59';
      // }
      
      andonEvtRecList(params).then(res=>{
        if(res.success){
          if(res.result.length==0){
             this.stats.processing = 0
             this.stats.pending = 0
             this.stats.confirming = 0
          }
          this.events = res.result.map(item=>{
            if(item.handlerBy){
              const handlerBy = []
              item.handlerBy.map(k=>{
                // Object.values(k).map(v=>{
                //   handlerBy.push(v)
                // })
                handlerBy.push(k.empName)
              })
              item.handlerBy = handlerBy.join('、')
            }else{
              item.handlerBy = '未分配'
            }
            if(item.handleEndTime&&item.handleStartTime){
              item.duration = this.formatDuration(item.handleEndTime,item.handleStartTime)
            }else{
              item.duration = '--'
            }
            if(item.status.value==='EVT_PROCESSING'){
              this.stats.processing ++
            }
            if(item.status.value==='EVT_PENDING'){
              this.stats.pending ++
            }
            if(item.status.value==='EVT_DONE'){
              this.stats.confirming ++
            }
            
            return item
          })
          // 数据加载完成后重新初始化滚动
          if (this.scrollInterval) {
            clearInterval(this.scrollInterval);
          }
          setTimeout(() => {
            this.startScroll();
          }, 500);
        }
      })
    },
    formatDuration(handleEndTime, handleStartTime) {
      if (!handleEndTime || !handleStartTime) {
        return '';
      }
      
      const endTime = new Date(handleEndTime);
      const startTime = new Date(handleStartTime);
      const diffMs = endTime - startTime;
      const diffMinutes = Math.floor(diffMs / (1000 * 60));
      
      if (diffMinutes >= 60) {
        const hours = Math.floor(diffMinutes / 60);
        const minutes = diffMinutes % 60;
        return `${hours}小时${minutes}分钟`;
      } else {
        return `${diffMinutes}分钟`;
      }
    },
    onDateChange() {
      // 日期变化时重新加载数据
      this.getList();
    },
    startScroll() {
      const tableBody = this.$refs.tableBody;
      if (!tableBody) return;

      // 确保有数据
      if (this.events.length === 0) return;

      // 计算实际的行高
      const firstRow = tableBody.querySelector('.table-row');
      if (!firstRow) return;
      
      const rowHeight = firstRow.offsetHeight;
      const totalRows = this.events.length;
      const containerHeight = tableBody.parentElement.offsetHeight;
      const totalHeight = totalRows * rowHeight + 200;
      
      // 只有当总高度大于容器高度时才滚动
      if (totalHeight <= containerHeight) {
        return;
      }
      
      // 计算最后一条数据完全显示时的滚动距离
      // 总高度 - 容器高度 = 最大滚动距离
      const maxScrollTop = totalHeight - containerHeight;
      let scrollTop = 0;

      this.scrollInterval = setInterval(() => {
        scrollTop += this.scrollStep;
        // 当滚动到最后一条数据完全显示时，重置到起始位置
        if (scrollTop >= maxScrollTop) {
          // 瞬间重置到起始位置，实现无缝循环
          tableBody.style.transition = 'none';
          scrollTop = 0;
          tableBody.style.transform = `translateY(-${scrollTop}px)`;
          // 等待重绘后恢复过渡效果
          setTimeout(() => {
            tableBody.style.transition = 'transform 0.1s linear';
          }, 100);
        } else {
          tableBody.style.transform = `translateY(-${scrollTop}px)`;
        }
      }, this.getScrollInterval());
    },
    updateScrollSpeed() {
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
      }
      this.startScroll();
    },
    getScrollInterval() {
      switch (this.scrollSpeed) {
        case 'fast':
          return 20;
        case 'medium':
          return 30;
        case 'slow':
        default:
          return 40;
      }
    },
    refreshData() {
      // 模拟刷新数据
      this.getList();
      // 这里可以添加实际的数据刷新逻辑
    }
  }
}
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.event-board {
  width: 100vw;
  height: 100vh;
  background: #1a1a1a;
  color: #fff;
  font-family: "Alibaba PuHuiTi 2.0", 'Avenir', Helvetica, Arial, sans-serif;
  padding: 30px;
  overflow: hidden;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;

    h1 {
      font-size: 48px;
      font-weight: bold;
      color: #fff;
    }

    .header-controls {
      display: flex;
      align-items: center;
      gap: 20px;

      .date-range-control {
        display: flex;
        align-items: center;
        gap: 10px;

        label {
          font-size: 24px;
          color: #ccc;
        }

        .date-inputs {
          display: flex;
          align-items: center;
          gap: 10px;

          input[type="date"] {
            font-size: 20px;
            padding: 8px 16px;
            background: rgba(0, 0, 0, 0.5);
            color: #fff;
            border: 1px solid rgba(255, 255, 255, 0.2);
            border-radius: 5px;
          }

          input[type="date"]::-webkit-calendar-picker-indicator {
            filter: invert(1);
            cursor: pointer;
          }

          .date-separator {
            font-size: 20px;
            color: #ccc;
          }
        }
      }

      .speed-control {
        display: flex;
        align-items: center;
        gap: 10px;

        label {
          font-size: 24px;
          color: #ccc;
        }

        select {
          font-size: 20px;
          padding: 8px 16px;
          background: rgba(0, 0, 0, 0.5);
          color: #fff;
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 5px;
        }
      }

      .refresh-btn {
        font-size: 20px;
        padding: 10px 24px;
        background: #1890FF;
        color: #fff;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          background: #40a9ff;
        }
      }
    }
  }

  .table-container {
    border-radius: 10px;
    overflow: hidden;

    .table-header {
      display: flex;
      background: #1890FF;

      .header-cell {
        padding: 20px;
        font-size: 24px;
        font-weight: bold;
        // border-right: 1px solid rgba(255, 255, 255, 0.2);
        white-space: nowrap;
        text-align: left;

        &:last-child {
          border-right: none;
        }

        &.device-col {
          flex: 1;
        }

        &.title-col {
          flex: 1;
        }

        &.handler-col {
          flex: 1;
        }

        &.duration-col {
          width: 160px;
        }

        &.status-col {
          width: 160px;
          text-align: center;
        }
      }
    }

    .table-body-container {
      max-height: calc(100vh - 300px);
      overflow: hidden;
      background: rgba(255, 255, 255, 0.05);

      .no-data {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 400px;
        font-size: 24px;
        color: #999;
        transform:none
      }

      .table-body {
        transition: transform 0.1s linear;
        width: 100%;

        .table-row {
          display: flex;
          position: relative;
          min-height: 72px;
          margin: 8px 0;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
          background: rgba(255, 255, 255, 0.05);

          &:before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            width: 4px;
            border-radius: 8px 0 0 8px;
          }

          &.EVT_PROCESSING:before {
            background: #1890FF;
          }

          &.EVT_PENDING:before {
            background: #F5B130;
          }
          &.EVT_DONE:before {
            background: #FA5151;
          }

          .row-cell {
            padding: 20px;
            font-size: 22px;
            white-space: nowrap;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            &:last-child {
              justify-content: center;
            }

            &.device-col {
              flex: 1;
            }

            &.title-col {
              flex: 1;
            }

            &.handler-col {
              flex: 1;
            }

            &.duration-col {
              width: 160px;
            }

            &.status-col {
              width: 160px;
            }

            .status-badge {
              padding: 6px 16px;
              border-radius: 20px;
              font-size: 18px;
              font-weight: bold;

              &.EVT_PROCESSING {
                background: #1890FF;
                color: #fff;
              }

              &.EVT_PENDING {
                background: #F5B130;
                color: #333;
              }
              &.EVT_DONE {
                background: #FA5151;
              }
            }
          }
        }
      }
    }

    .statistics-bar {
      display: flex;
      justify-content: center;
      gap: 40px;
      padding: 20px;
      margin-top: 10px;
      background: rgba(0, 0, 0, 0.3);
      border-top: 1px solid rgba(255, 255, 255, 0.1);

      .stat-item {
        display: flex;
        align-items: center;
        font-size: 24px;
        gap: 10px;

        .stat-dot {
          width: 24px;
          height: 24px;
          border-radius: 50%;

          &.EVT_PENDING {
            background: #F5B130;
          }

          &.EVT_PROCESSING {
            background: #1890FF;
          }

          &.EVT_DONE {
            background: #FA5151;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/device/Event.vue